// Single source of truth for the currently-selected company.
// Company-scoped API calls must not fire before a company is selected
// (e.g. super admin before CompanySelection) — they would hit `company/null`
// or send a null X-COMPANY-ID header and fail.

const INVALID = new Set(["", "null", "undefined"]);

/** Returns the selected companyId, or null if none is selected. */
export function getSelectedCompanyId(): string | null {
  const id = localStorage.getItem("companyId");
  if (!id || INVALID.has(id)) return null;
  return id;
}

/** True when a valid company is selected. */
export function hasSelectedCompany(): boolean {
  return getSelectedCompanyId() !== null;
}
